export default class FormHelper {
  static convertToString(value) {
    if (value === null) {
      return "--null--";
    }
    if (typeof value === "boolean") {
      return value.toString();
    }
    if (Array.isArray(value)) {
      return value.join(",");
    }
    return value;
  }

  static convertToValue(value) {
    if (value === "--null--") {
      return null;
    }

    if (typeof value === "string" && value.trim() === "") {
      return null;
    }

    if (["true", "false"].indexOf(value) !== -1) {
      return JSON.parse(value);
    }

    return value;
  }

  static denormalizeData(data) {
    return Object.keys(data).reduce((denormalized, field) => {
      return { ...denormalized, [field]: FormHelper.convertToString(data[field]) };
    }, {});
  }

  static normalizeData(data) {
    return Object.keys(data).reduce((normalized, field) => {
      return { ...normalized, [field]: FormHelper.convertToValue(data[field]) };
    }, {});
  }
}
